<div class="login-container">
  <div class="left-side">
    <div class="content-wrapper">
      <div class="message">
        <h1>Welcome! Log in to manage workforce and operations efficiently</h1>
        <p class="subtitle">
          Access and manage employee records, site details, and shift assignments—all in one place.
        </p>
      </div>
      <div class="image-wrap">
        <img src="../../../assets/images/slider1.png" alt="Welcome Image" class="welcome-image">
      </div>
    </div>
  </div>

  <div class="right-side">
    <div class="login-form-wrapper">
      <div class="logo-wrapper">
        <img src="../../../assets/images/upspl_log.png" alt="UPS Logo" class="logo" />
      </div>

      <div *ngIf="isLogin" class="form-container">
        <div class="form-header">
          <p class="login-title">Please log in to continue</p>
        </div>

        <!-- ✅ show global error message for invalid credentials -->
        <div *ngIf="authenticationError || passwordResetMessage" class="alert alert-danger">
          {{ passwordResetMessage }}
        </div>

        <form class="login-form" role="form" (ngSubmit)="onSubmit()" [formGroup]="loginForm">
          <!-- Username Field -->
          <div class="form-group">
            <label for="username" class="form-label">Username</label>
            <input
              type="text"
              id="username"
              formControlName="username"
              placeholder="Enter your Employee ID or Mobile No"
              class="form-control"
              (input)="onInputChange()"
            />
            <!-- ✅ required validation -->
            <div class="text-danger" *ngIf="
              loginForm.get('username')?.touched &&
              loginForm.get('username')?.hasError('required')
            ">
              Username is required.
            </div>
          </div>

          <!-- Password Field -->
<div class="form-group">
  <label for="password" class="form-label">Password</label>

  <div class="password-wrapper">
    <input
      [type]="showPassword ? 'text' : 'password'"
      id="password"
      formControlName="password"
      placeholder="Enter your password"
      class="form-control"
      (input)="onInputChange()"
    />
    <i
      class="pi"
      [ngClass]="showPassword ? 'pi-eye' : 'pi-eye-slash' "
      (click)="togglePassword()"
    ></i>
  </div>

  <div class="text-danger" *ngIf="
    loginForm.get('password')?.touched &&
    loginForm.get('password')?.hasError('required')
  ">
    Password is required.
  </div>

  <div class="forgot-password-link">
    <a href="forgot-password" class="forgot-link">Forgot Password?</a>
  </div>
</div>

          <button type="submit" class="btn btn-login" [disabled]="isLoading">
            {{ isLoading ? 'Logging in...' : 'Log In' }}
          </button>

          <div class="divider">
            <span class="divider-text">or</span>
          </div>

          <a href="/login-otp" class="btn btn-otp">Login Using OTP</a>
        </form>
      </div>
    </div>
  </div>
</div>
